import Component from './Interval.vue';

export default Component;
